module.exports = __webpack_public_path__ + "static/media/defisnap.92a17e9a.svg";